import { DashboardOptions } from '../providers/AppContext';

const TOOLKIT_DASH_OPTIONS = new Set<DashboardOptions>([
  DashboardOptions.GHE_INPUTS,
  DashboardOptions.GHE_RESULTS,
  DashboardOptions.GHE_ANALOGUE_TABLES,
  DashboardOptions.GHE_SELECTION_EXPORT,
  DashboardOptions.GHE_IX_TABLES
]);

export const isToolkitEnabled = (): boolean =>
  process.env.REACT_APP_SHOW_TOOLKIT?.toLowerCase() === 'true';

export const isFlowUnitsEnabled = (): boolean =>
  process.env.REACT_APP_SHOW_FLOW_UNITS?.toLowerCase() === 'true';

export const isToolkitDashOption = (
  dashOption?: DashboardOptions | string
): boolean =>
  dashOption !== undefined && TOOLKIT_DASH_OPTIONS.has(dashOption as DashboardOptions);
